import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AuthContext } from 'context/AuthContext';

const AccionesCell = ({ onEdit, onDelete }) => {
  const { hasRole } = useContext(AuthContext);
  const isClient = hasRole?.('client') === true;   // por si hasRole no existe aún

  // Si es cliente, no renderiza nada
  if (isClient) return null;

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <IconButton aria-label="editar" color="info" onClick={onEdit}>
        <EditIcon />
      </IconButton>
      <IconButton aria-label="eliminar" color="error" onClick={onDelete}>
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

AccionesCell.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default AccionesCell;
